import { Hidden, Image, SpacerWrapper } from '@ahmdigital/ui';
import { reduce, set } from 'lodash/fp';
import React from 'react';

import styles from './styles.module.sass';
import verticalDashedLineImage from './images/vertical-dashed-line.svg';

type SnakeSeparatorProps = {
  hideOn?: ('xs' | 'sm' | 'md' | 'lg' | 'df')[];
};

const SnakeSeparator = ({ hideOn }: SnakeSeparatorProps) => {
  const hiddenProps = reduce((propsObject, value) => set(value, true, propsObject), {}, hideOn);
  return (
    <Hidden isBlock {...hiddenProps}>
      <SpacerWrapper variant={['paddingTopSpacer7', 'paddingBottomSpacer7', styles.wrapper]}>
        <Image src={verticalDashedLineImage.src} role="presentation" />
      </SpacerWrapper>
    </Hidden>
  );
};

SnakeSeparator.defaultProps = {
  hideOn: [],
};

export default SnakeSeparator;
